import Button from './Button.jsx';

/**
 * An empty screen is an invitation to act, so the action is required-by-habit:
 * pass `actionLabel` + (`actionTo` | `onAction`) unless there is genuinely
 * nothing for the person to do.
 */
export default function EmptyState({
  icon = '🧺',
  title,
  message,
  actionLabel,
  actionTo,
  onAction,
  className = '',
}) {
  return (
    <div
      className={`flex flex-col items-center justify-center rounded-crate border border-dashed border-oat-darker bg-oat/30 px-6 py-14 text-center ${className}`}
    >
      <span className="text-4xl" aria-hidden="true">
        {icon}
      </span>
      <h3 className="mt-4 font-display text-xl text-heading">{title}</h3>
      {message && <p className="mt-2 max-w-sm text-balance text-sm text-ink-muted">{message}</p>}
      {actionLabel && (actionTo || onAction) && (
        <Button className="mt-6" to={actionTo} onClick={onAction} size="md">
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
